"use client";

import { useState } from "react";
import { trackLead } from "@/lib/analytics";

export function FooterNewsletter() {
  const [email, setEmail] = useState("");
  const [kvkk, setKvkk] = useState(false);
  const [status, setStatus] = useState<"idle" | "loading" | "done" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!kvkk) {
      setStatus("error");
      setMessage("Devam etmek için KVKK metnini onaylayın");
      return;
    }
    setStatus("loading");
    setMessage("");
    try {
      const res = await fetch("/api/newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, kvkk, website: "" }),
      });
      const data = (await res.json()) as { success: boolean; error?: string };
      if (!res.ok || !data.success) {
        setStatus("error");
        setMessage(data.error ?? "Bir hata oluştu");
        return;
      }
      setStatus("done");
      trackLead("newsletter-footer");
      setMessage("Kaydedildi! %10 kodun e-postanda.");
      setEmail("");
      setKvkk(false);
    } catch {
      setStatus("error");
      setMessage("Bağlantı hatası");
    }
  };

  return (
    <div className="w-full max-w-[500px]">
      <form
        onSubmit={handleSubmit}
        className="flex h-12 w-full items-center gap-2 rounded-2xl bg-White px-4 py-3 outline outline-1 outline-offset-[-1px] outline-Background-dark transition focus-within:outline-2 focus-within:outline-Primary"
      >
        <label htmlFor="footer-email" className="sr-only">E-posta adresin</label>
        <input
          id="footer-email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="E-posta"
          autoComplete="email"
          inputMode="email"
          disabled={status === "loading"}
          className="w-full min-w-0 flex-1 bg-transparent text-sm font-normal leading-4 text-zinc-900 placeholder:text-500 focus:outline-none disabled:opacity-60"
        />
        <button
          type="submit"
          disabled={status === "loading"}
          aria-label="Bültene katıl"
          className="flex shrink-0 items-center justify-center text-Primary-dark transition hover:text-Primary active:scale-95 disabled:opacity-50"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" aria-hidden="true">
            <path d="M5 12h14" />
            <path d="m12 5 7 7-7 7" />
          </svg>
        </button>
      </form>
      <label className="mt-2 flex cursor-pointer items-start gap-2 text-xs leading-5 text-500">
        <input
          type="checkbox"
          checked={kvkk}
          onChange={(e) => setKvkk(e.target.checked)}
          className="mt-0.5 h-4 w-4 shrink-0 accent-Primary"
        />
        <span>
          <a href="/kvkk" className="underline hover:text-Primary">KVKK metnini</a> okudum, bülten için onaylıyorum.
        </span>
      </label>
      {message && (
        <p role="status" className={`mt-1.5 text-xs font-medium ${status === "error" ? "text-Tertiary" : "text-emerald-600"}`}>
          {message}
        </p>
      )}
    </div>
  );
}
